/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class EntityRequestApiService {
  constructor(private api: CustomerApiService) {}

  addRequestEntity(data: any): Observable<any> {
    return this.api.post('/v1/entity_requests/add', data);
  }
}
